<template>
  <div :class="[$style.container, slides.length > 1 && $style.containerMultiSlides]">
    <Slider1XP is-sidebar>
      <figure v-for="(slide, index) in slides" :key="index" :class="$style.slide">
        <div :class="slide.video ? $style.video : $style.image">
          <a :class="{ [$style.videoLink]: slide.video }" @click="openModal(slide)">
            <Play v-if="slide.video" :is-focused="isFocused" :is-hovered="isHovered" />
            <img v-if="slide.video" :alt="slide.alt" :src="slide.image" />

            <ImageMagnifier
              v-else
              :alt="slide.alt"
              :scale="2"
              :src="slide.image"
              :zoom-src="slide.imageZoom || slide.image"
            />
          </a>
        </div>
        <figure :class="$style.figure">
          <figcaption v-if="slide.title || slide.text" :class="$style.caption">
            <div :class="$style.title">
              {{ slide.title }}
            </div>
            <p v-if="slide.text" :class="$style.text">{{ slide.text }}</p>
          </figcaption>
        </figure>
      </figure>
    </Slider1XP>
    <Modal
      :is-modal-open="isModalOpen"
      :is-product="isProduct"
      :is-video="isVideo"
      @close-modal="closeModal"
    >
      <iframe
        v-if="isVideo"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        :data-src="currentSlideSrc"
        frameborder="0"
      />
      <img v-else alt="" :src="currentSlideSrc" />
    </Modal>
  </div>
</template>

<script setup>
import Slider1XP from '../Slider1XP/Slider1XP.vue';
import Modal from '../Modal/Modal.vue';
import ImageMagnifier from '../ImageMagnifier/ImageMagnifier.vue';
import Play from '../Play/Play.vue';
import { mergeSwitchWtParams } from '../../utils/tracking';
import { ref } from 'vue';

const props = defineProps({
  slides: {
    type: Array,
    default: () => [],
  },
  zoomOrientation: {
    type: String,
    default: () => 'left',
  },
  wtParams: Object,
});

const isModalOpen = ref(false);
const isVideo = ref(false);
const isProduct = ref(false);
const currentSlideSrc = ref(null);
const wtTrack = ref(window.wtTrack);

const mergeWtParams = (globalWtParams, itemWtParams, itemParams) =>
  mergeSwitchWtParams(globalWtParams, itemWtParams, itemParams);

const openModal = (slide) => {
  isProduct.value = slide.isProduct || false;
  if (slide.video) {
    isVideo.value = true;
    currentSlideSrc.value = slide.video;
    slide.wtParams &&
      wtTrack.value(
        { cat: slide.wtParams.doctype },
        mergeWtParams(
          props.wtParams,
          {
            ...slide.wtParams,
            filename: slide.video,
          },
          {},
        ),
      );
  } else {
    currentSlideSrc.value = slide.imageZoom || slide.image;
  }
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
  currentSlideSrc.value = null;
  isVideo.value = false;
};
</script>

<style module lang="scss">
@forward './SidebarSlider.scss';
</style>
